a.item.display.qrcode = (function(){
	var my = {
		popup:function(o){
			var o = o || {};
			var iid = o.iid || null;
			var result = o.result || {};
			var token = a.popup.create({
				slideFrom:'fromleft',
				title:'QR code',
				css_class:'',
				ready:function(token){
					var qrcodeareaid = a.shared.createToken();
					tpl.run({
						tpl:'/tpl/item/display/qrcode/page.ejs?v='+v,
						data:{
							qrcodeareaid:qrcodeareaid
						},
						cb:function(c){
							var win = $('#popupid_'+token);
							$('#popupid_'+token+'>.ic').empty().append(c).ready(function(){
								// Show QR code
								my.showQRCode(result.item.uuid,qrcodeareaid,win);
								// Assign new QR label
								$('button[data-action="assign-qr"]',win).unbind('click').click(function(){
									my.assignNewQR(iid,qrcodeareaid,win);
								});
								// Or, hide button if not permitted
								if (!a.s.ac.allow('content','qr')) {
									$('button[data-action="assign-qr"]',win).parent().hide();
								}
							});
						}
					});
				}
			});
		},
		showQRCode:function(code,qrcodeareaid,win){
			var qrcode = new QRCode(qrcodeareaid, {
				text: code,
				colorDark : "#000000",
				colorLight : "#ffffff",
				correctLevel : QRCode.CorrectLevel.H
			});
		},
		assignNewQR:function(iid,qrcodeareaid,win){
			if (a.s.ac.allow('content','qr') && confirm('By scanning a new QR label, any previously assigned QR label code will be replaced. Do you want to proceed?')) {
				a.qrscanner.open({
					scanRaw:true,
					result:function(qr){
						$.ajax({
							type:'POST',
							url:'/api/item/qr/assign/',
							data:{
								iid:iid,
								qr:qr.substring(18,63),
								force:0,
								token:localStorage.getItem('token'),
								accountname:localStorage.getItem('accountname')
							},
							dataType:'json',
							cache: false,
							success:function(result) {
								if (result.success) {
									a.s.growl.create('Success','The new QR label code was assigned to the item',{});
								}
								else {
									if (result.qrinuse) {
										a.s.growl.create('Error','The QR label code is already in use by the item '+result.qrinuse_item.name,{});
									}
									else {
										a.s.growl.create('Error','Unable to assign new QR code to item',{});
									}
								}
							}
						}).done(function(){
							
						});
					}
				});
			}
		}
	}
	return my;
}());